export const CONTENT_PLATFORM = Object.freeze({
  infoScreen: 648970003,
  website: 648970002
});

export function contentPlatformValues(value) {
  const values = Array.isArray(value) ? value : String(value ?? '').split(',');
  return values
    .map((item) => String(item ?? '').trim())
    .filter(Boolean)
    .map(Number)
    .filter(Number.isFinite);
}

export function isInfoScreenSchedule(row) {
  const platforms = contentPlatformValues(row?.crfd1_platform);
  return platforms.length === 0 || platforms.includes(CONTENT_PLATFORM.infoScreen);
}

export function buildInfoScreenPlatformFilter(fieldName = 'crfd1_platform') {
  return `(${fieldName} eq null or Microsoft.Dynamics.CRM.ContainValues(PropertyName='${fieldName}',PropertyValues=%5B'${CONTENT_PLATFORM.infoScreen}'%5D))`;
}
